import type React from 'react';
import { useCoachQuery } from '@src/api/api-hooks/coaches/useCoachQuery.ts';
import * as st from './styles.module.scss';

interface Props {
  id: number;
}

export const Experience: React.FC<Props> = ({ id }) => {
  const { data: coach } = useCoachQuery({ id: String(id) });

  const getExperience = (experience?: number) => {
    if (!experience) {
      return;
    }

    if (experience === 1) {
      return `Стаж работы - ${experience} год`;
    } else if (experience < 5) {
      return `Стаж работы - ${experience} года`;
    } else if (experience > 4) {
      return `Стаж работы - ${experience} лет`;
    }
  };

  return <span className={st.exp}>{getExperience(Number(coach?.experience))}</span>;
};
